// select box styling with Tom Select
// https://tom-select.js.org/

const { default: TomSelect } = require("tom-select");

up.compiler('.tom-select', (element) => {
    const settings = tomSelectOptions(element);
    new TomSelect(element, settings);
})



function tomSelectOptions(element){
    const settings = {}

    // basic configuration
    settings['optgroupValueField'] = 'label'
    settings['plugins'] = []

    // server side configuration
    settings['create'] = element.dataset.tsCreate === 'true'
    settings['createFilter'] = element.dataset.tsCreateFilter
    settings['persist'] = element.dataset.tsPersit === 'true'
    settings['maxOptions'] = parseInt(element.dataset.tsMaxOptions) || null;
    settings['placeholder'] = element.dataset.tsPlaceholder
    settings['allowEmptyOption'] = element.dataset.tsAllowEmpty != 'false' && element.dataset.tsAllowEmpty != undefined 
    if (element.dataset.tsMaxItems !== undefined) {
        settings['maxItems'] = parseInt(element.dataset.tsMaxItems)
    }

    if (element.dataset.tsLiveSearchUrls !== undefined) {
        settings['load'] = tomSelectLoadData(element.dataset.tsLiveSearchUrls.split(', '))
        settings['score'] = scoreMatchAll;
    }

    if (element.dataset.tsCustomRenderer !== undefined) {
        if (settings['render'] === undefined) {
            settings['render'] = {}
        }
        const rendererName = element.dataset.tsCustomRenderer;
        const rendererFunction = window[rendererName];
        settings['render']['option'] = rendererFunction;
        settings['render']['optgroup_header'] = defaultOptGroupHeaderRenderer;
        settings['render']['optgroup'] = defaultOptGroupRenderer;
    }

    if (element.dataset.tsHideClearButton !== 'true') {
        settings['plugins'].push('clear_button')
    }
    if (element.dataset.tsLiveSearch === 'true' || element.dataset.tsLiveSearchUrls !== undefined) {
        settings['plugins'].push('dropdown_input')
    }
    if (element.dataset.tsDragnDrop === 'true') {
        settings['plugins'].push('drag_drop')
    }

    return settings
}

function tomSelectLoadData(searchUrls){
    return function(query, callback) {
            const select = this;
            Object.keys(select.options).forEach(key => {
                if (select.options[key].remote) {
                    select.removeOption(key, true);
                }
            });

            const fetchPromises = searchUrls.map((url) => {
            const fullUrl = `${url}${encodeURIComponent(query)}`;
            return fetch(fullUrl)
                .then(response => response.json())
                .then(json => {
                    json = json || []
                    const select = this;
                    json.forEach(item => {
                        item.remote = true;
                        if (item.optgroup && !select.optgroups.hasOwnProperty(item.optgroup)) {
                            select.addOptionGroup(item.optgroup, { label: item.optgroup });
                        }
                    });
                    return json;
                })
                .catch(() => []);
        });
        
        Promise.all(fetchPromises)
            .then(results => {
                const combinedResults = results.flat();
                callback(combinedResults);
            })
            .catch(() => {
                callback([]);
            });
    }
}

function scoreMatchAll(search){
    var score = this.getScoreFunction(search);
    return function(item) {
        return score(item) + 1;
    };
}

function defaultOptGroupHeaderRenderer(data) {
    return '<div class="optgroup-header fs-4 text-warning-emphasis text-center mx-auto">' + data.label + '</div>';
}

function defaultOptGroupRenderer(data) {
    let optgroup = document.createElement('div');
    optgroup.className = 'optgroup';
    optgroup.appendChild(data.options);
    return optgroup;
};


window.renderBucketOrProjectItems = function(item, escape) {
    if(("type" in item) && item['type'] === 'project') {
        const project_type = `text-${item.source}`
        return `<div class="py-2 d-flex border-top">
            <div class="color-dot me-3 align-self-center">
                <svg class="svg-inline--fa fa-circle ${project_type}" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"></path></svg>
            </div>
            <div class="d-flex flex-grow-1 row">
                <div class="mb-1 d-flex justify-content-between">
                    <span class="h3 mb-0">
                        ${ escape(item.text) }
                    </span>
                    <span class="text-muted ms-auto">${ escape(item.year) } - ${ escape(item.value) }</span>
                </div>
                <div class="description">${ escape(item.client) }</div>
            </div>
        </div>`;
    } else if(("type" in item) && item['type'] === 'depot') {
        return `<div class="py-2 d-flex border-top">
            <div class="color-dot me-3 align-self-center">
                <i class="fa-solid fa-${escape(item.icon)}"></i>
            </div>
            <div class="d-flex flex-grow-1 row">
                <div class="mb-1 d-flex justify-content-between">
                    <span class="h3 mb-0">
                        ${ escape(item.text) }
                    </span>
                    <span class="text-muted ms-auto">${ escape(item.value) }</span>
                </div>
                <div class="description">${ escape(item.kind) }</div>
            </div>
        </div>`;
    } else {
        return `<div class="py-2 d-flex border-top">
            <div class="mx-1">
                <span class="">
                    ${ escape(item.text) }
                </span>
            </div>
        </div>`;
    }
    
}
